import styles from "./HomeIcon.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";

/**
 * An icon that signifies the homepage.
 */
export function HomeIcon() {
  return (
    <div className={styles.container}>
      <FontAwesomeIcon icon={faHome} className={styles.homeIcon} />
    </div>
  );
}
